import { Container } from "@/components/Container";
import { Typography } from "@mui/material";

import { CarouselCards } from "./CarouselCards";
import { SecurityCardsProps } from "./types";

export const SecurityCards: React.FC<SecurityCardsProps> = ({ infoCardTitle, infoCards }) => {
  return (
    <Container pt={{ xs: 6, sm: 6, md: 14 }} pl={{ xs: "24px", sm: "24px", md: "84px", lg: "81px" }} px={0}>
      <Typography fontSize={32} fontWeight={600} color="#0045B5" mb={5}>
        {infoCardTitle}
      </Typography>

      <CarouselCards items={infoCards} />
    </Container>
  );
};
